import { autoInjectable, singleton } from 'tsyringe';

@singleton()
@autoInjectable()
export default class Config {
    public skipLegacyIntersection = true;
}
